/** Owned fixed dataset catalog. Dataset definitions continue to reference their existing source domains. */
export enum OttopilotAnalyticsWorkspaceCapabilityUdoTemplateKey {
    dataset = "af0df31f-b7a6-4a9d-93db-30b8e1f5a2c9",
}
